import coffeePoint from '@/assets/img/users-cases/coffee-point.webp';
import coffeePointHow from '@/assets/img/users-cases/coffee-point-how.webp';
import coffeePointResult from '@/assets/img/users-cases/coffee-point-result.webp';

export default {
  slug: 'coffee-point',
  order: 24,
  title: '3D Coffee Point Render',
  subtitle: 'Small retail spaces visualized in 3D and 360° views',
  tags: ['CommercialLayouts', 'InteriorDesign'],

  images: {
    hero: coffeePoint,
    aboutTop: coffeePointHow,
    aboutBottom: coffeePointResult,
  },

  howText:
    'We put together 2D and 3D layouts and interior design solutions focused on quick setup and clear brand positioning.',

  resultText:
    'The visuals support marketing presentations and commercial negotiations.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
